import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import Routes from './desktop';
import { Provider } from 'react-redux';
import store from './store';
import Toastr from './components/toastr/Toastr.jsx';
import RequestProgress from './components/RequestProgress';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { ThemeProvider } from "styled-components";
import { applicationTheme } from "./styles/themes/applicationTheme.js";
import { GlobalStyles } from "./styles/globalStyles.js";

library.add(fas);

ReactDOM.render(
  <Provider store={store}>
  <ThemeProvider theme={applicationTheme}>
    <BrowserRouter>
    <GlobalStyles />
      <Toastr />
      <RequestProgress />
      {/* Uma arvore so para qualquer dispositivo: o layout e responsivo (mobile first). */}
      <Routes />
    </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
);
